/* TODO change to AWS config and CHANGE PACKAGE.JSON to URL (i.e. clientURL) */
const awsmobile = {
   "aws_project_region": "us-east-2",
   "aws_cognito_identity_pool_id": "us-east-2:cc8994db-99d1-4890-ad2b-276f1a744a64",
   "aws_cognito_region": "us-east-2",
   "aws_user_pools_id": "us-east-2_75eLY9pMc",
   "aws_user_pools_web_client_id": "7rnum863r74ct6ftk3l8j8khpv"
}
export default awsmobile;
